import React from 'react';


const Contact = () => {
    return (
        <div className="row">
      <div className="container-fluid">

        <h3>Στοιχεία Επικοινωνίας</h3>
        <address>
          <strong>Architecture, Processes and Infrastructure:</strong><br />
          <a href="mailto:itadmin@evolutionprojects.gr">itadmin@evolutionprojects.gr</a>
          <br />
          <strong>Support:</strong><br />
          <a href="mailto:support@evolutionprojects.gr">support@evolutionprojects.gr</a>
        </address>
      </div>
    </div>
    );
}

export default Contact;